export default function navTabs() {
    if (!$('.nav-tabs').length) {
        return;
    }

    const hash = window.location.hash;
    // always show the first tab if no hash is set
    const tabSelector = hash ? `[href="${hash}"]` : ':first';
    $(`.nav-tabs a${tabSelector}`).tab('show');

    // keep track of the hash in the url when a nav tab is shown
    // this is done just for control panel nav tabs, since cockpit nav tabs are differently handled in the cockpit/router.ts
    $("#sl-js-control-panel-tab > li > a").on('show.bs.tab', function (e) {
        history.pushState(undefined, undefined, $(e.target).attr('href'));
    });

    responsiveNavTabs();
}

// enable responsive nav tabs
function responsiveNavTabs(): void {
    $.fn.extend({
        responsiveTabs: function () {
            this.addClass('responsive-tabs');
            this.append($('<i class="fas fa-chevron-down"></i>'));
            this.append($('<i class="fas fa-chevron-up"></i>'));

            this.on('click', 'li.active > a, i.fas', function () {
                this.toggleClass('open');
            }.bind(this));

            this.on('click', 'li:not(.active) > i.fas', function () {
                this.removeClass('open');
            }.bind(this));
        }
    });

    (<any>$('.nav.nav-tabs')).responsiveTabs();
}